import { render, staticRenderFns } from "./DelegationForm.vue?vue&type=template&id=d98f3db0&"
import script from "./DelegationForm.vue?vue&type=script&lang=ts&"
export * from "./DelegationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports